var render = function () {
  var _vm$meeting;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "미팅현황",
      "fullscreen": "",
      "persistent": "",
      "max-width": "1080",
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("미팅현황")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v("미팅현황을 확인해보세요.")])]), _c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16"
  }, [_vm._v(_vm._s((_vm$meeting = _vm.meeting) === null || _vm$meeting === void 0 ? void 0 : _vm$meeting.title))]), _c('v-card-text', [_c('v-sheet', _vm._l(_vm.items, function (_ref2) {
    var application = _ref2.application,
      schedule = _ref2.schedule;
    return _c('meeting-status-item', _vm._b({
      key: application === null || application === void 0 ? void 0 : application._id,
      staticClass: "mb-30",
      attrs: {
        "value": schedule
      },
      on: {
        "search": _vm.init
      }
    }, 'meeting-status-item', {
      meeting: _vm.meeting,
      application: application,
      schedulesAvailable: _vm.schedulesAvailable
    }, false));
  }), 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }